import useSWR from "swr";
import { ApiResponse } from "../typings/interfaces";
import { PublishedBrandModel } from "../typings/models";

const useBrands = <T = PublishedBrandModel>(props = {}) => {
  const { data, isLoading, error, mutate, isValidating } = useSWR<
    ApiResponse<T[]>
  >(`/brands/published`, { keepPreviousData: true });

  return {
    items: data?.data ?? [],
    isValidating,
    isLoading,
    error: (!data?.data && data?.error) || error || null,
    mutate,
  };
};

export default useBrands;
